import { render } from "./PairingView.vue?vue&type=template&id=16a70073&scoped=true"
import script from "./PairingView.vue?vue&type=script&lang=js"
export * from "./PairingView.vue?vue&type=script&lang=js"

import "./PairingView.vue?vue&type=style&index=0&id=16a70073&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a70073"]])

export default __exports__